import { Extra } from 'src/app/core/services/action.service';
import { Select2Data } from 'src/app/core/state/_models/general.model';
import { alertPresets } from 'src/app/shared/services/alert.service';
import { SweetAlertOptions } from 'sweetalert2';

export const notificationTypes: Array<Select2Data> = [
  {
    value: 'sms',
    label: 'SMS',
  },
  {
    value: 'email',
    label: 'Email',
  },
];

export const notiType = ['Notification - email - On Add', 'Notification - email - On Update', 'Notification - sms - On Add', 'Notification - sms - On Update','Notification - email - Date & Time', 'Notification - sms - Date & Time']
export const typeArr = ['On Add', 'On Update']

export const triggerTypes: Array<Select2Data> = [
  {
    value: 'new_record',
    label: 'New Record',
  },
  {
    value: 'update_record',
    label: 'Update Record',
  },
  {
    value: 'date_and_time',
    label: 'Date & Time'
  }
];

export const condition_option = [
  {
    label: 'String | Integer',
    options: [
      { value: 'empty', label: 'is blank or empty' },
      { value: 'has value', label: 'is not blank (has value)' },
      { value: 'is equal', label: 'is equal to' },
      { value: 'is not equal', label: 'is not equal to' },
      { value: 'contain', label: 'contains' },
      { value: 'start with', label: 'starts with' },
      { value: 'end with', label: 'does not start with' },
    ],
  },
  {
    label: 'Number',
    options: [
      { value: 'greater than or equal to', label: 'greater than or equal to' },
      { value: 'less than or equal to', label: 'less than or equal to' },
    ],
  },
  {
    label: 'Date',
    options: [
      { value: 'days_before_today', label: 'Days before today' },
      { value: 'before_date', label: 'Before' },
      { value: 'on_or_before_date', label: 'On or before' },
      { value: 'after_date', label: 'After' },
      { value: 'on_or_after_date', label: 'On or after' },
      { value: 'between_date', label: 'Between' },
      { value: 'not_between_date', label: 'Not between' },
    ],
  },
  {
    label: 'Available Data',
    options: [
      { value: 'is equal to user', label: 'is equal to user' },
      { value: 'currentuser', label: 'is current user' },
      { value: 'equal to value in field', label: 'equal to value in field' },
      {
        value: 'not equal to value in field',
        label: 'not equal to value in field',
      },
    ],
  },
];

export const timeOptions: Array<any> = [
  {
    value: 0,
    label: '12:00 AM',
  },
  {
    value: 1,
    label: '01:00 AM',
  },
  {
    value: 2,
    label: '02:00 AM',
  },
  {
    value: 3,
    label: '03:00 AM',
  },
  {
    value: 4,
    label: '04:00 AM',
  },
  {
    value: 5,
    label: '05:00 AM',
  },
  {
    value: 6,
    label: '06:00 AM',
  },
  {
    value: 7,
    label: '07:00 AM',
  },
  {
    value: 8,
    label: '08:00 AM',
  },
  {
    value: 9,
    label: '09:00 AM',
  },
  {
    value: 10,
    label: '10:00 AM',
  },
  {
    value: 11,
    label: '11:00 AM',
  },
  {
    value: 12,
    label: '12:00 PM',
  },
  {
    value: 13,
    label: '01:00 PM',
  },
  {
    value: 14,
    label: '02:00 PM',
  },
  {
    value: 15,
    label: '03:00 PM',
  },
  {
    value: 16,
    label: '04:00 PM',
  },
  {
    value: 17,
    label: '05:00 PM',
  },
  {
    value: 18,
    label: '06:00 PM',
  },
  {
    value: 19,
    label: '07:00 PM',
  },
  {
    value: 20,
    label: '08:00 PM',
  },
  {
    value: 21,
    label: '09:00 PM',
  },
  {
    value: 22,
    label: '10:00 PM',
  },
  {
    value: 23,
    label: '11:00 PM',
  },
];

export const alertDefaultExtra: Extra = {
  success: {
    show: true,
    message: '',
    title: '',
    showSwal: false,
    alertOptions: <SweetAlertOptions>alertPresets.saveSuccess,
  },
  error: {
    show: true,
    title: '',
    showResponseError: false, // show error comming in response
  },
};

export const notificationColumns = [
  { Name: 'Notification Key', FieldName: 'notification_key', FieldType: "VARCHAR(255)"},
  { Name: 'Subject', FieldName: 'subject', FieldType: "VARCHAR(255)"},
  { Name: 'Type', FieldName: 'type', FieldType: "ENUM" , Values: notiType.map((type) => ({ Value: type})),},
  { Name: 'Last Run', FieldName: 'last_run', FieldType: "DATETIME"},
]
export const webhookColumns = [
  { Name: 'Notification Key', FieldName: 'notification_key', FieldType: "VARCHAR(255)"},
  { Name: 'Name', FieldName: 'name', FieldType: "VARCHAR(255)"},
  { Name: 'Type', FieldName: 'type', FieldType: "ENUM" , Values: typeArr.map((type) => ({Value: 'Webhook - '+type}))},
  { Name: 'Last Run', FieldName: 'last_run', FieldType: "DATETIME"},
]
export const processColumns = [
  { Name: 'Process Key', FieldName: 'process_key', FieldType: "VARCHAR(255)"},
  { Name: 'Name', FieldName: 'name', FieldType: "VARCHAR(255)"},
  { Name: 'Type', FieldName: 'type', FieldType: "ENUM" , Values: typeArr.map((type) => ({Value: 'Process - '+type})),},
]
export const subscriptionColumns = [
  { Name: 'Notification Key', FieldName: 'notification_key', FieldType: "VARCHAR(255)"},
  { Name: 'Subject', FieldName: 'subject', FieldType: "VARCHAR(255)"},
  { Name: 'Report', FieldName: 'report', FieldType: "VARCHAR(255)",IsExternalOptions:true, IsBulkUpdateAllowed:true, formFieldKey:'ReportKey'},
  { Name: 'Delivery Schedule', FieldName: 'delivery_schedule', FieldType: "ENUM", Values: ['weekly','daily'].map((type) => ({ Value: type})),IsExternalOptions:true, IsBulkUpdateAllowed:true, formFieldKey:'Frequency'},
  { Name: 'Schedule Hour', FieldName: 'schedule_hour', FieldType: "ENUM", Values: timeOptions.map((type) => ({ Value: type.label})),IsExternalOptions:true, IsBulkUpdateAllowed:true, formFieldKey:'Hour'},
  { Name: 'Last Run', FieldName: 'last_run', FieldType: "DATETIME"},
]

